Ext.define('SA.view.LocationInfoMenu', {
    alias: 'widget.map-location-info-menu',
    extend: 'Ext.menu.Menu',

    cls: 'sa-location-info',
    shrinkWrap: 1,

    initComponent() {
        this.callParent();

        this.on('hide', this.onMenuHide);

        this.loadLocations();

        this.refresh();
    },

    loadLocations() {
        var attributeId = this.attribute,
            coordinate = this.coordinate,
            fields = SA.data.LocationsCache.getQueryFields(),
            country = this.record.getCountry(),
            censusRelease = this.censusRelease,
            censusReleaseUnits = SA.data.GeographicUnits.idsForCountryAndCensusRelease(country, censusRelease),
            discoverableUnits = SA.AppController.getCurrentProject().getDiscoverableGeographicUnits(),
            units = censusReleaseUnits.filter(unit => discoverableUnits.includes(unit)),
            query;

        if (!this.record.getGeographicRelease()) {
            return;
        }

        if (attributeId) {
            fields.push(attributeId);
        }

        query = this.request = SA.data.Query.from({
            type: 'locations',

            fields,
            limit: SA.data.Query.MAX_LIMIT,
            sort: [['desc', 'geographicUnit'].concat(units)],

            where: [
                'and',
                ['contains', ...coordinate],
                ['in', 'geographicUnit'].concat(units)
            ]
        });

        query.addSuccess(this.onLocationLoad, this);

        query.run();
    },

    onDestroy() {
        var record = this.record,
            Locations = SA.data.LocationsCache;

        if (Locations.toLocationSeries(record.getInfoLocation()) === Locations.toLocationSeries(this.location)) {
            record.setInfoLocation(null);
        }

        Ext.destroyMembers(this, 'request');

        this.callParent();
    },

    onLocationLoad(locations) {
        var me = this,
            attributeId = this.attribute,
            attribute = attributeId && SA.data.AttributesCache.get(attributeId),
            mapModel = this.record,
            geographicRelease = mapModel.getGeographicRelease(),
            Units = SA.data.GeographicUnits,
            units = Units.findIds({
                censusRelease: this.censusRelease,
                country: mapModel.getCountry(),
                minimum: mapModel.getGeographicUnit()
            }),
            attributeValuesByLocationSeries = attributeId
                ? new Map(locations.map(location => [location.locationSeries, location[attributeId]]))
                : null,
            alternateLocationItems,
            selectedLocation;

        locations = locations.map(location => {
                SA.data.LocationsCache.add(location);

                return SA.data.LocationsCache.get(location.locationSeries);
            })
            .filter(({geographicReleases}) => geographicReleases.includes(geographicRelease));

        Ext.suspendLayouts();

        if (locations.length) {
            selectedLocation = locations[0];

            locations.forEach(location => {
                if (units.includes(location.geographicUnit)) {
                    selectedLocation = location;
                }
            });

            this.location = selectedLocation;

            mapModel.setInfoLocation(selectedLocation);

            this.defaults = {
                getLocation: () => selectedLocation.locationSeries
            };

            alternateLocationItems = locations.map(location => {
                var geographicUnit = Units.get(location.geographicUnit).singularName;

                return {
                    encodeText: false,
                    hideOnClick: false,
                    location,
                    text: '<span class="sa-location-info-alternate-location-geographic-unit">' + geographicUnit + ':</span>' + Ext.util.Format.locationRenderer(location),

                    handler() {
                        var parentMenu = this.parentMenu;

                        mapModel.setInfoLocation(location);

                        selectedLocation = me.location = location;

                        parentMenu.hide();
                        parentMenu.parentItem.parentMenu.deactivateActiveItem();

                        me.refresh();
                    }
                };
            });

            this.add(
                {
                    xtype: 'simple-container',
                    cls: 'sa-location-info-header',

                    items: [
                        {
                            xtype: 'component',
                            cls: 'sa-location-info-title',
                            html: 'Location'
                        }, {
                            xtype: 'close-button',
                            closeAction: 'hide'
                        }
                    ]
                }, {
                    xtype: 'component',
                    cls: 'sa-location-info-location-name x-selectable',
                    tpl: '<div class="sa-location-info-location-name-label">Location Name</div><div>{location:locationRenderer}</div>',

                    refresh() {
                        this.update({location: selectedLocation});
                    }
                }, {
                    xtype: 'component',
                    cls: 'sa-location-info-location-data x-selectable',

                    tpl: [
                        '<div class="sa-location-info-location-data-label">Value for Mapped Data:</div>',
                        '<div class="sa-location-info-location-data-value">{value}</div>'
                    ],

                    refresh() {
                        var value = 'N/A',
                            rawValue;

                        if (attribute) {
                            rawValue = attributeValuesByLocationSeries.get(selectedLocation.locationSeries);
                            value = SA.data.AttributesCache.formatValue(rawValue, attribute.formatString);
                        }

                        this.update({value});
                    }
                }, {
                    xtype:'menuseparator'
                }, {
                    text: 'Add Location to Project',

                    handler() {
                        mapModel.addLocation(selectedLocation);

                        mapModel.save();

                        SA.data.RecentLocations.add(selectedLocation);
                    }
                }, {
                    xtype: 'menu-add-remove-favorite-location'
                }, {
                    xtype: 'menu-set-location-alias'
                }, {
                    cls: 'sa-location-info-alternate-locations-parent-item',
                    text: 'Alternate Locations',

                    menu: {
                        cls: 'sa-location-info-alternate-locations-submenu sa-menu-compact',
                        items: alternateLocationItems
                    },

                    refresh() {
                        this.menu.items.each(item => {
                            item.setVisible(item.location !== selectedLocation);
                        });
                    }
                }
            );

            SA.data.RecentLocations.addClicked(selectedLocation);
        }
        else {
            this.add({
                xtype: 'component',
                cls: 'sa-location-info-no-location-found-message',
                html: 'A corresponding location could not be found for this point.'
            });
        }

        Ext.resumeLayouts(true);

        this.refresh();
    },

    onMenuHide() {
        Ext.destroy(this);
    },

    refresh() {
        var xy = this.xy,
            x = xy[0],
            closeButton = this.closeButton,
            top, left;

        this.show();

        Ext.suspendLayouts();

        this.items.each(item => {
            if (item.refresh) {
                item.refresh();
            }
        });

        Ext.resumeLayouts(true);

        if (this.alignDir === 'l') {
            left = x + 80;
            top = xy[1] - this.getHeight() / 2;
        }
        else {
            left = x - this.getWidth() - 80;
            top = xy[1] - this.getHeight() / 2;
        }

        this.showAt(left, top);
        this.doConstrain();

        this.setLoading(this.request.isPending() ? 'Loading location details…' : false);

        if (closeButton) {
            closeButton.showAt(this.getWidth() - 27, -3);
        }
    }
});